import{useTranslation as r}from"react-i18next";var t=function(t){var e=r().t;return function(r,a){return e((t||"relativeTime")+"_"+a,{value:r})}};export{t as default};
